/* eslint-disable max-len */

export const environment = {
  production: true,
  debug: true,
  name: 'dev',
  captchKey: '6Lfqw88ZAAAAAO8aoC4V4xFLzsFTmxxvm9zKvX0H',
  disable3rdPartyModule: false,
  disableBoardModule: false,
  disableTrainingCtr: false,
  queryListLimit: 1000,
  region: 'us-east-1',
  // AI Chat foundation feature flag (enabled on dev — backed by the deployed regwatch-ai-inference-dev stack)
  aiChatEnabled: true,
  // Artifact Expert agent (document analysis from the Artifact Registry).
  // Default OFF: the button and the agent are hidden while false.
  artifactExpertEnabled: false,
  // LOCAL DEV ONLY — points the AI chat at the local Bedrock proxy (infra/cdk/local/serve-bedrock.mjs).
  // MUST stay '' in any committed environment. Leaving a localhost URL here is a bug.
  aiChatLocalEndpoint: '',
  collectionDataPrefetchEnabled: true,
};
